import { Box, Divider, FormControl, FormHelperText, Typography } from '@mui/material';

import React, { FC, ReactNode } from 'react';

const SummaryLine: FC<{
	label: ReactNode;
	value: any;
	error?: boolean;
	errorMessage?: string;
	showErrorMessagePlaceholder?: boolean;
	boldLabel?: boolean;
	labelPadding?: string;
	alignValueRight?: boolean;
	showBackground?: boolean;
	valueFontWeight?: number | string;
	showTopDivider?: boolean;
}> = ({
	label,
	value,
	error,
	errorMessage,
	showErrorMessagePlaceholder = true,
	boldLabel = false,
	labelPadding = '0.75rem 0',
	alignValueRight = false,
	showBackground = false,
	valueFontWeight = 600,
	showTopDivider = false,
}) => {
	return (
		<FormControl sx={{ width: '100%' }} error={error}>
			{showTopDivider && <Divider sx={{ width: '100%' }} />}
			<Box
				sx={{
					display: 'flex',
					width: '100%',
					color: error ? 'error.main' : '',
					backgroundColor: showBackground ? 'background.paper' : 'transparent',
					padding: '0 0.5rem',
				}}
			>
				<Typography sx={{ width: '50%', padding: labelPadding, fontWeight: boldLabel ? 600 : 'normal' }} variant='body2'>
					{label}
				</Typography>
				<Typography
					sx={{ fontWeight: valueFontWeight, width: '50%', padding: '0.75rem 0', textAlign: alignValueRight ? 'right' : 'left' }}
					variant='body2'
				>
					{value}
				</Typography>
			</Box>
			{showErrorMessagePlaceholder && <FormHelperText sx={{ margin: 0, padding: '0 0 0 1rem' }}>{errorMessage}</FormHelperText>}
			<Divider sx={{ width: '100%' }} />
		</FormControl>
	);
};
export default SummaryLine;
